import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import BadgeCDS, {
  BadgeColorVariant,
  BadgeType,
} from 'app/shared/componentsRestyled/coreDesignSystem/BadgeCDS';
import PropTypes from 'prop-types';

import { statusDotStyles, statusStyles } from './AiChatStatusIndicator.styles';

const AiChatStatusIndicator = ({ isConnected = true }) => (
  <Box sx={statusStyles}>
    <BadgeCDS
      colorVariant={isConnected ? BadgeColorVariant.GREEN : BadgeColorVariant.GRAY}
      sx={statusDotStyles}
      type={BadgeType.DOT}
    />
    <Typography color="textSecondary" variant="regular12">
      {isConnected ? 'Online & Ready' : 'Connecting...'}
    </Typography>
  </Box>
);

AiChatStatusIndicator.propTypes = {
  isConnected: PropTypes.bool,
};

export default memo(AiChatStatusIndicator);
